import React, { FC } from 'react'
import LogoTransfix from 'transfix-ui/components/LogoTransfix'
import { Link } from 'transfix-ui/core'
import Box from 'transfix-ui/core/Box'
import Typography from 'transfix-ui/core/Typography'
import { ClockAlertOutlineIcon } from 'transfix-icons'
import { brandColors } from 'transfix-ui'
import { useTextStyles } from './DriverValidationPage'

export const DriverVerificationExpiredPage: FC = () => {
  const classes = useTextStyles()

  return (
    <Box display='flex' flexDirection='column' alignItems='center' paddingX='32px'>
      <Box marginTop='32px' marginBottom='72px'>
        <LogoTransfix width={130} />
      </Box>
      <Box alignItems='center'>
        <Box
          width='80px'
          height='80px'
          bgcolor={brandColors.warning0}
          borderRadius='20px'
          marginBottom='16px'
          padding='16px'>
          <ClockAlertOutlineIcon color='warning1' size='xxlarge' />
        </Box>
      </Box>
      <Box marginBottom='16px'>
        <Typography variant='subtitle1' className={classes.subtitleOne} align='center'>
          This link is invalid or expired
        </Typography>
        <Box height='4px' />
        <Typography variant='body2' className={classes.bodyTwo} align='center'>
          This may be an expired code or this may be a fraudulent attempt. Ask the driver to provide
          the active code or{' '}
          <Link href='tel:6469484480'>
            <b>contact Transfix.</b>
          </Link>
        </Typography>
      </Box>
    </Box>
  )
}
